<template>
  <v-container fluid>
    <PageHeading
      text="Анкеты физ. лиц"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
    </PageHeading>
    <v-row>
      <v-col>
        <GridPersonalDetails
          ref="grid"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/page-heading/PageHeading'
import gridPageInterfaceMixin from '@/interfaces/grid-page-interface-mixin'
import GridPersonalDetails from '@/pages/personal-details/grid/GridPersonalDetails'
export default {
  name: 'PagePersonalDetails',
  metaInfo () {
    return {
      title: 'Анкеты физ. лиц'
    }
  },
  components: { GridPersonalDetails, PageHeading },
  mixins: [gridPageInterfaceMixin]
}
</script>

<style scoped>

</style>
